import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { PanoPlayer, PositionalMedia, Browser } from '../../../legacy'
import isEqual from 'lodash-es/isEqual'
import idx from 'idx'
import { MEDIA_TYPES } from 'aria-viewer/tour'
import { isFullScreenActive } from 'aria-viewer/utils/fullScreen'

import { showUIButton, showSkipButton, setPanoramaParams } from 'aria-viewer/tour/tourActions'
import {
    setCurrentXY,
    setPanoStartLatLon,
    panoDragStarted,
    panoDragStopped,
    panoramaTapped,
    panoAutoRotateStarted,
    panoAutoRotateStopped,
    setDragHintDetails,
    clearForceRotate,
    deviceMotionStart,
    registerPanoPlayer,
    panoramaMouseWheel,
    setCursor,
} from '../actions/panoramaActions'
import UriHandler from 'aria-viewer/utils/uriHandler'
import { PLATFORM, VIRTUAL_HOST } from 'aria-viewer/tour/constants/queryConstants'
import { playPositionalMediaVideo } from '../actions/positionalMediaActions'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import MobileDetect from 'aria-viewer/utils/mobileDetect'
import { transformMedia } from 'aria-viewer/media/mediaTransformer'
import { playAudio, stopAudio, AUDIO_PM } from 'aria-viewer/audiomanager/audioManagerActions'
import InteractiveElementsContainer from '../../../interactive-element/containers/common/InteractiveElements'
import { handleDraw, setCam } from 'aria-viewer/interactive-element/observables/positionObservable'
import { handleProgress } from 'aria-viewer/interactive-element/observables/positionalMediaObservable'
import {
    handleDragStart,
    handleDragEnd,
    handleAutoRotate,
} from 'aria-viewer/interactive-element/observables/panoObservable'
import compose from 'recompose/compose'
import {
    registerPositionalMedia,
    setPositionalMediaStatus,
    setPositionalMediaProgress,
    resetPositionalMedia,
    MediaStates,
} from 'aria-viewer/interactive-element'
import { setVisited } from '../../../interactive-element/actions/common'
import { fromEventPattern } from 'rxjs/observable/fromEventPattern'
import { merge } from 'rxjs/observable/merge'
import DraggingHint from './DraggingHint'
import debounce from 'lodash-es/debounce'
import QueryParamUtils from 'aria-viewer/utils/queryParamUtils'

import { CursorState } from '../constants'
const EventEmitter = require('eventemitter3')

const isPhone = MobileDetect.phone(),
    isMobile = MobileDetect.mobile(),
    isWindows7 =
        navigator.appVersion.indexOf('Windows NT 7.0') != -1 || navigator.appVersion.indexOf('Windows NT 6.1') != -1

const PanoMomentIDs = {
    /* media_id: panoMoments-id */
    233531: '5900a997062f50000bc3fa3b', //NAU: ropes course
    235018: '5910aa6358ddda000be32c9f', //Brandeis: color war
}

// TODO => document specific propTypes for
// TODO... PanoPlayerWrapper to keep track
// TODO... of data flow/rendering attempts

class PanoPlayerWrapper extends PureComponent {
    constructor(props) {
        super(props)
        this.R = { panoWrapper: undefined }

        // this indicates whether or not if the camera had already rotated to start
        this.rotatedToStart = false
        // indicates if we already auto rotated
        this.autoRotated = false

        this.handleOnDragEnd = debounce(this.handleOnDragEnd, 250)
        this.handleDeviceMotionStart = debounce(this.handleDeviceMotionStart, 250)
        this.eventEmitter = new EventEmitter()
        this.handleOnDragEnd = debounce(this.handleOnDragEnd, 250)
        this.handleDeviceMotionStart = debounce(this.handleDeviceMotionStart, 250)
        this.handleMouseWheel = debounce(this.handleMouseWheel, 250)
    }

    initializePanorama = props => {
        const {
            options,
            setPanoramaParams,
            secondaryOptions: { coordOptions } = {},
            panoStartLatLon,
            setPanoStartLatLon,
            resetPositionalMedia,
            enableInteractiveElements,
            useResponsiveUI,
        } = props

        this.panoPlayer && this.panoPlayer.destroy({ causedBySwap: true })

        /* Hardcoded panomoments. Detects main media id and early exit */
        if (this.supportsPanomoments(options.id)) {
            props.onLoad()
            return null
        }

        if (enableInteractiveElements) resetPositionalMedia()

        let addOptions = {
            selector: this.R.panoWrapper,
            startLat: props.options.start_lat,
            startLon: props.options.start_lon,
            showHint: false,
            disableZoom: useResponsiveUI,
        }

        if (coordOptions) {
            if (typeof coordOptions.lat != 'undefined') {
                addOptions.startLat = coordOptions.lat
            }
            if (typeof coordOptions.lon != 'undefined') {
                addOptions.startLon = coordOptions.lon
            }

            //don't show hint if the pano rotates from enter/exit to start
            if (!this.rotatedToStart && coordOptions.positionVar != 'start') {
                addOptions.showHint = false
            } else {
                this.rotatedToStart = true
            }
        }

        const { panorama } = (this.panoPlayer = new PanoPlayer(
            Object.assign({}, props.options, addOptions, { eventEmitter: this.eventEmitter })
        ))
        this.props.registerPanoPlayer(this.panoPlayer)

        //reset the panoStartLatLon when the stop changes
        if (panoStartLatLon.lat != 0 && panoStartLatLon.lon != 180) {
            setPanoStartLatLon({
                lat: 0,
                lon: 180,
                isSetByTrigger: false,
            })
        }

        setPanoramaParams({
            size: this.panoPlayer.zoomLevels[this.panoPlayer.zoom],
            panoType: this.panoPlayer.type,
        })

        const dragStart$ = fromEventPattern(handler =>
            this.panoPlayer.on('dragstart', e => {
                const { panoDragStarted } = this.props
                panoDragStarted && panoDragStarted(e)

                handler()
            })
        )
        const dragEnd$ = merge(
            // in PanoPlayer.js dragend is only called if touchmove/mousemove occured,
            // need touchend or mouseup callback regardless of touchmove/mousemove
            fromEventPattern(handler => this.panoPlayer.on('touchend', handler)),
            fromEventPattern(handler => this.panoPlayer.on('mouseup', handler))
        )
        props.onDragStart(dragStart$)
        props.onDragEnd(dragEnd$)

        this.panoPlayer.on('viewReady', this.handleViewReady)
        this.panoPlayer.on('panoLoaded', this.handlePanoLoaded)
        this.panoPlayer.on('mousedown', this.handleOnClick)
        this.panoPlayer.on('mouseup', this.handleOnMouseUp)
        this.panoPlayer.on('touchstart', this.handleOnClick)
        this.panoPlayer.on('dragend', this.handleOnDragEnd)
        this.panoPlayer.on('devicemotionstart', this.handleDeviceMotionStart)
        this.panoPlayer.on('mousewheel', this.handleMouseWheel)

        this.panoPlayer.embed()

        const draw$ = fromEventPattern(this.addDrawListener, this.removeDrawListener)
        this.props.onDraw(draw$)

        if (enableInteractiveElements) this.props.setCam(this.panoPlayer.panorama.camera.getCamera())
    }

    handleProps = props => {
        const {
            options,
            canvasSize,
            secondaryOptions,
            mainMediaInitialized,
            altMainMedia,
            isHybridtour,
            forceRotateParams,
            clearForceRotate,
        } = props
        if (forceRotateParams.forceRotate) {
            this.panoPlayer.setPosition(
                { lat: forceRotateParams.lat, lon: forceRotateParams.lon },
                {
                    speed: 60,
                    callback: () => {},
                }
            )
            clearForceRotate()
        } else {
            const hasIntro = secondaryOptions && (secondaryOptions.hasIntro && !altMainMedia && isHybridtour)
            const hasCoordOptions = secondaryOptions && (secondaryOptions.coordOptions && !altMainMedia && isHybridtour)
            const secondaryOptionsSetOrientation = hasIntro || hasCoordOptions

            if (!this.lastOptions || (this.lastOptions && this.lastOptions.id != options.id)) {
                this.initializePanorama(props)
            }

            if (!isEqual(this.lastOptions, options) || (secondaryOptions && !secondaryOptions.mainMediaInitialized)) {
                this.lastOptions = props.options

                if (secondaryOptionsSetOrientation) {
                    this.setOrientation(
                        secondaryOptions.coordOptions,
                        secondaryOptions.startCoord,
                        mainMediaInitialized
                    )
                }
            }

            if (canvasSize) this.resize(canvasSize)

            if (isHybridtour && secondaryOptions) {
                this.setOrientation(secondaryOptions.coordOptions, secondaryOptions.startCoord, mainMediaInitialized)
            }
        }
    }

    resize = ({ width, height }) => {
        this.panoPlayer && this.panoPlayer.setSize(width, height)
    }

    setOrientation = (coordOptions, startCoord, mainMediaInitialized) => {
        if (coordOptions && this.panoPlayer && coordOptions.walkingDirection) {
            this.rotate(coordOptions.lat, coordOptions.lon, coordOptions.walkingDirection)
        } else if (
            this.panoPlayer &&
            mainMediaInitialized &&
            coordOptions &&
            !coordOptions.walkingDirection &&
            !this.rotatedToStart &&
            !this.rotateToStartTimeout
        ) {
            this.rotateToStartTimeout = setTimeout(() => {
                this.rotate(startCoord.lat, startCoord.lon, null)
            }, 600) // add 600ms for the pano to rotate to start coords
        } else {
            this.props.showUIButton(true)
        }
    }

    setAutoRotate = ({ auto, speed }) => {
        this.panoPlayer.setAutoRotate(auto, speed)
        this.props.onAutoRotate(!!auto)
    }
    rotate = (lat, lon, walkingDirection) => {
        this.panoPlayer.setPosition(
            { lat, lon },
            {
                speed: 60,
                callback: () => {
                    setTimeout(() => {
                        const { onRotate } = this.props
                        onRotate && onRotate(walkingDirection)
                        if (!walkingDirection && !this.rotatedToStart && this.panoPlayer) {
                            //dont auto rotate the pano if it was walked into the stop
                            this.rotatedToStart = true
                        }
                    }, 300)
                },
            }
        )
    }

    handleDeviceMotionStart = () => {
        const { deviceMotionStart } = this.props
        deviceMotionStart && deviceMotionStart()
    }

    handleMouseWheel = () => {
        const { panoramaMouseWheel } = this.props
        panoramaMouseWheel && panoramaMouseWheel()
    }

    handlePanoLoaded = () => {
        const {
            options,
            positionalmedia,
            secondaryOptions: { coordOptions } = {},
            isHybridtour,
            showUIButton,
            positionalMediaCanPlayOverGuide,
            setVisited,
            autoplay,
        } = this.props

        this.props.onLoad && this.props.onLoad()

        //if it's a hybrid tour, dont show the nav button until after the pano has rotated
        if (isHybridtour) showUIButton(false)

        if (positionalmedia) {
            const scope = this
            options.objs.forEach(pm => {
                if (pm.owner_id === options.id) {
                    const positonalMedia = new PositionalMedia(
                        {
                            ...pm,
                            autoplay: pm.autoplay && autoplay,
                            scene: scope.panoPlayer.panorama.scene,
                            status: 'live',
                            //proper media objects format for Positionalmedia
                            media:
                                pm.media_item.item_type === MEDIA_TYPES.video
                                    ? {
                                          photoURL: pm.media_item.video.largeurl,
                                          videoURL: !UriHandler.isInSameSubDomain(
                                              pm.media_item.video.url,
                                              window.location.href
                                          )
                                              ? UriHandler.appendCorsQueryParam(pm.media_item.video.url)
                                              : pm.media_item.video.url,
                                      }
                                    : {
                                          photoURL: transformMedia({ media: pm.media_item.photo }).urls.large,
                                          videoURL: false,
                                      },
                            type: pm.media_item.item_type,
                            points: pm.position,
                            viewMode: true,
                            customUI: pm.custom_ui, //handle by system, ie viewer
                            //If custom_ui from content perspective, lets allow direct touch.
                            disableTouch: pm.custom_ui === false,
                            /**
                             * onPositional Media Play
                             * Indicates if a positional media has played
                             * @param bool keepAudio indicates if previous pm was playing
                             * @return void
                             */
                            onPositionalMediaPlay: (e, { keepAudio, id }) => {
                                this.setAutoRotate(false)
                                this.props.setPositionalMediaStatus(id, MediaStates.PAUSE)

                                if (!positionalMediaCanPlayOverGuide) this.props.playAudio(AUDIO_PM)
                            },
                            onPositionalMediaPause: (e, { keepAudio, id, currentTime, duration }) => {
                                this.props.setPositionalMediaStatus(id, MediaStates.PLAY)

                                if (!positionalMediaCanPlayOverGuide && !keepAudio) this.props.stopAudio(AUDIO_PM)

                                // /***
                                //  * pause() is also called when media ends, so we need to add logic to
                                //  * determine if it was a manual pause:
                                //  ***/
                                // if (currentTime !== 0 && currentTime !== duration) {
                                //     setVisited({
                                //         id,
                                //         type: 'positionalMedia'
                                //     });
                                // }

                                // Per revised spec, autoplay DOES count as an interaction
                                setVisited({
                                    id,
                                    type: 'positionalMedia',
                                })
                            },
                            onFailedToPlay: po => {
                                //Autoplay issue, this will allow us to play once we have interaction
                                document.addEventListener(
                                    'mousedown',
                                    function() {
                                        po.play()
                                    },
                                    { once: true }
                                )
                            },
                            onPositionalMediaTimeUpdate: (e, { percentComplete, id }) => {
                                this.props.handleProgress({ id, progress: percentComplete })
                            },
                            onPositionalMediaEnded: (e, { id, autoplay }) => {
                                this.props.setPositionalMediaStatus(id, MediaStates.REPLAY)
                                // Per revised spec, autoplay DOES count as an interaction
                                //if (!autoplay) {
                                setVisited({
                                    id,
                                    type: 'positionalMedia',
                                })
                                //}
                            },
                            onVideoPlay: this.props.playPositionalMediaVideo,
                        },
                        this.panoPlayer.panorama
                    )

                    this.props.registerPositionalMedia(positonalMedia)
                }
            })
            PositionalMedia.loadVideoMetaOnly = !Browser.is('safari')
        }
    }

    handleViewReady = () => {
        const { secondaryOptions, enableInteractiveElements, useResponsiveUI } = this.props

        // Need to ensure we're passing scene, renderer, and camera on re-renders
        if (enableInteractiveElements) this.setState({ viewReady: true })

        //Auto Rotate
        if (!isPhone && secondaryOptions.coordOptions && secondaryOptions.coordOptions.positionVar === 'start') {
            this.setAutoRotate({
                auto: true,
                speed: 0.06,
            })
        }

        if (useResponsiveUI) {
            this.setAutoRotate({
                auto: true,
                speed: 0.06,
            })
        }
    }

    addDrawListener = handler => {
        this.panoPlayer.panorama.scene.addEvent('draw', handler)
    }
    removeDrawListener = handler => {
        this.panoPlayer.panorama.scene.removeEvent('draw', handler)
    }

    componentDidMount() {
        this.handleProps(this.props)
    }

    componentWillReceiveProps(newProps) {
        this.handleProps(newProps)
    }

    componentWillUnmount() {
        const { showSkipButton, isSkipButtonVisible } = this.props

        this.panoPlayer && this.panoPlayer.destroy()

        !isSkipButtonVisible && showSkipButton(true)
    }

    handleOnMouseUp = e => {
        this.props.setCursor(CursorState.GRAB)
    }

    handleOnDragEnd = e => {
        const { panoDragStopped } = this.props
        panoDragStopped && panoDragStopped(e)
    }

    handleOnClick = e => {
        if (this.props.isDraggingHintVisible) this.props.setDragHintDetails({ isVisible: false })

        this.props.setCursor(CursorState.GRABBING)

        this.props.panoramaTapped()
        // code that actually stops autorotation in ./PanoPlayer

        this.props.onAutoRotate(false)
    }

    supportsPanomoments(mediaId) {
        const data = Browser.getBrowserData()

        const isVhost = UriHandler.hasQueryParam(PLATFORM) && UriHandler.getParamValue(PLATFORM) == VIRTUAL_HOST

        return (
            !isMobile &&
            !isWindows7 &&
            !isVhost &&
            // Chrome
            (data.browser === 'Chrome' ||
                // Safari
                data.browser === 'Safari' ||
                // Edge
                data.browser === 'Edge' ||
                // Firefox
                data.browser === 'Firefox') &&
            typeof PanoMomentIDs[mediaId] !== 'undefined'
        )
    }

    renderPanomoments(mediaId) {
        const panoMomentID = PanoMomentIDs[mediaId]
        return (
            <div
                className="panoiframe"
                style={{ width: window.innerWidth, height: window.innerHeight, pointerEvents: 'all' }}
            >
                <iframe
                    id="embedPanoMoment"
                    width={window.innerWidth}
                    height={window.innerHeight}
                    pano="PanoMoments"
                    allowFullScreen
                    frameBorder="0"
                    scrolling="no"
                    src={'https://my.panomoments.com/embed/' + panoMomentID}
                />
            </div>
        )
    }

    render() {
        const {
            isPanoAutoRotating,
            mainMediaInitialized,
            sizes,
            options,
            style,
            isPanoramaBlurred,
            enableInteractiveElements,
            isLandscape,
            useResponsiveUI,
            cursor,
        } = this.props
        /* hardcoded panomoments. Renders iframe instead of pano */
        if (this.supportsPanomoments(options.id)) {
            return this.renderPanomoments(options.id)
        }
        const scene = idx(this.panoPlayer, _ => _.panorama.scene)
        const camera = idx(this.panoPlayer, _ => _.panorama.camera.getCamera())
        const renderer = idx(this.panoPlayer, _ => _.panorama.renderer)
        if (camera && isMobile) {
            camera.zoom = isLandscape ? 2 : 1
            camera.updateProjectionMatrix()
        } else if (camera && useResponsiveUI) {
            camera.zoom = isFullScreenActive() ? 1 : 2
            camera.updateProjectionMatrix()
        }

        if (renderer) {
            // Turn off automatic render sorting to deal with depth buffer issues
            // https://stackoverflow.com/questions/8763603/transparent-textures-behaviour-in-webgl
            // https://stackoverflow.com/questions/15514274/three-js-how-to-control-rendering-order/15514587
            renderer.sortObjects = false
        }

        return (
            <div>
                <div
                    ref={c => (this.R.panoWrapper = c)}
                    className="panoWrapper"
                    style={{
                        cursor,
                        position: 'relative',
                        overflow: 'hidden',
                        display: 'inline-block',
                        pointerEvents: mainMediaInitialized || !isPanoAutoRotating ? 'all' : 'none',
                        filter: isPanoramaBlurred ? 'blur(3px)' : 'initial',
                        transition: 'filter 1s',
                        ...style,
                    }}
                />

                <InteractiveElementsContainer
                    setAutoRotate={this.setAutoRotate}
                    container={this.R.panoWrapper}
                    scene={scene}
                    camera={camera}
                    renderer={renderer}
                    sizes={sizes}
                    enableInteractiveElements={enableInteractiveElements}
                    mainSceneImageResource={this.props.options.urls && this.props.options.urls.medium}
                />

                <DraggingHint />
            </div>
        )
    }
}

PanoPlayerWrapper.propTypes = {
    enableInteractiveElements: PropTypes.bool,
}

PanoPlayerWrapper.defaultProps = {
    enableInteractiveElements: true,
}

export default compose(
    connect(state => ({
        isDraggingHintVisible: state.getIn(['panorama', 'draggingHint', 'isVisible']),
        cursor: state.getIn(['panorama', 'cursor']),
        useResponsiveUI: QueryParamUtils.useResponsiveUI(),
        autoplay: state.getIn(['audioManager', 'autoplay']),
    })),
    connect(
        mapSelectorsToProps([
            'mainMediaInitialized',
            'altMainMedia',
            'isHybridtour',
            'isWalkingtour',
            'isSkipButtonVisible',
            'panoStartLatLon',
            'isPanoAutoRotating',
            'isPanoramaBlurred',
            'isLandscape',
            'positionalMediaCanPlayOverGuide',
            'forceRotateParams',
        ]),
        {
            panoDragStarted,
            panoDragStopped,
            panoramaTapped,
            playPositionalMediaVideo,
            showUIButton,
            playAudio,
            stopAudio,
            showSkipButton,
            setPanoramaParams,
            setCurrentXY,
            setPanoStartLatLon,
            panoAutoRotateStarted,
            panoAutoRotateStopped,
            registerPositionalMedia,
            registerPanoPlayer,
            setPositionalMediaStatus,
            setPositionalMediaProgress,
            resetPositionalMedia,
            clearForceRotate,
            setVisited,
            setDragHintDetails,
            deviceMotionStart,
            panoramaMouseWheel,
            setCursor,
        },
        (stateProps, dispatchProps, ownProps) => ({
            ...stateProps,
            ...dispatchProps,
            ...ownProps,
            onDraw: handleDraw,
            onDragStart: handleDragStart,
            onDragEnd: handleDragEnd,
            onAutoRotate: handleAutoRotate,
            setCam: setCam,
            handleProgress,
        })
    )
)(PanoPlayerWrapper)
